import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex h-[5.5rem] w-full items-center justify-center rounded-xl bg-background-normal transition-colors duration-300 group-hover:bg-primary-pale" }
const _hoisted_2 = { class: "mb-0 mt-2 truncate text-center text-xs font-medium text-context-1 transition-colors duration-300 disabled:text-gray-500 group-hover:text-primary" }

import { type LocationAsRelativeRaw } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'MemberDrawerContentWidgetLink',
  props: {
    label: {},
    icon: {},
    route: {},
    disabled: { type: Boolean }
  },
  emits: ["widget-link-click"],
  setup(__props: any, { emit: __emit }) {


const props = __props

const emit = __emit

function handleClick() {
  if (props.disabled) return

  emit('widget-link-click')
}

return (_ctx: any,_cache: any) => {
  const _component_sword_icon = _resolveComponent("sword-icon")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.disabled ? 'div' : 'router-link'), _mergeProps(__props.disabled ? {} : { to: __props.route }, {
    class: ["group w-[5.5rem] border-0 bg-transparent p-0 text-inherit no-underline", { 'cursor-not-allowed opacity-50': __props.disabled }],
    onClickNative: handleClick
  }), {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_sword_icon, {
          name: __props.icon,
          class: "!h-auto !w-10 fill-context-1 transition-colors duration-300 disabled:fill-gray-500 group-hover:fill-primary"
        }, null, 8, ["name"])
      ]),
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t(__props.label)), 1)
    ], undefined, true),
    _: 1
  }, 16, ["class"]))
}
}

})